'use client'

import { motion, useReducedMotion } from 'framer-motion'
import type { ReactNode } from 'react'

import {
  softEditorialEase,
  softMotionDuration,
} from '@/shared/components/motion/motion-tokens'

type ScrollRevealProps = {
  children: ReactNode
  className?: string
  delay?: number
  distance?: number
  variant?: 'lift' | 'scale'
  viewportAmount?: number
}

export function ScrollReveal({
  children,
  className,
  delay = 0,
  distance = 14,
  variant = 'lift',
  viewportAmount = 0.2,
}: ScrollRevealProps) {
  const prefersReducedMotion = useReducedMotion()

  return (
    <motion.div
      className={className}
      initial={{
        opacity: 0,
        scale: variant === 'scale' ? 0.985 : 1,
        y: distance,
      }}
      whileInView={{
        opacity: 1,
        scale: 1,
        y: 0,
      }}
      viewport={{
        amount: viewportAmount,
        margin: '0px 0px -6% 0px',
        once: true,
      }}
      transition={{
        delay: prefersReducedMotion ? 0 : delay,
        duration: prefersReducedMotion
          ? 0
          : variant === 'scale'
            ? softMotionDuration.revealEmphasis
            : softMotionDuration.reveal,
        ease: softEditorialEase,
      }}
    >
      {children}
    </motion.div>
  )
}
